import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import MuiButtonBase from '@mui/material/ButtonBase';
import withStyles from '@mui/styles/withStyles';
import clsx from 'clsx';
export var styles = function (theme) { return ({
    /* your custom classes or class overrides go here */
    root: {
        marginTop: 'auto',
        marginBottom: 0,
        lineHeight: 1.5,
        opacity: 1,
        position: 'relative',
        color: 'inherit',
        fontWeight: 500,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(3),
        fontSize: theme.typography.pxToRem(14),
        fontFamily: theme.typography.fontFamily,
        '& + &': {
            marginLeft: 0,
        },
        '&::before': {
            content: '""',
            opacity: 0,
            background: theme.palette.primary.main,
            width: 'auto',
            height: 0,
            display: 'block',
            position: 'absolute',
            bottom: 0,
            top: 'auto',
            left: theme.spacing(1),
            right: theme.spacing(1),
            transition: theme.transitions.create(['height', 'width', 'opacity']),
            borderRadius: '1px',
        },
        '&:hover:not(.Mui-active)': {
            '&::before': {
                opacity: 0.25,
                height: '2px',
            },
        },
        '&:focus, &.Mui-active': {
            '&::before': {
                opacity: 0.7,
                height: '2px',
            },
        },
        '&:active': {
            '&::before': {
                opacity: 0.7,
                height: '2px',
            },
        },
        '&.NavButton-topRow': {
            '&::before': {
                bottom: 'auto',
                top: '100%',
            },
        },
    },
    active: {},
    topRow: {
        paddingBottom: 0,
    },
    sizeSmall: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 300,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1.5),
        '&.NavButton-topRow': {
            paddingBottom: 0,
        },
    },
    touchRipple: function (_a) {
        var _b = _a.size, size = _b === void 0 ? 'default' : _b;
        return ({
            bottom: size === 'small' ? '-5px' : 0,
            height: 'auto',
        });
    },
    disabled: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
    focusVisible: {},
    dense: {
        paddingBottom: theme.spacing(2),
        '&.NavButton-sizeSmall': {
            paddingBottom: theme.spacing(1),
        },
    },
    vertical: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        transition: theme.transitions.create(['font-weight']),
        '&::before': {
            content: '""',
            opacity: 0,
            background: theme.palette.primary.main,
            display: 'block',
            position: 'absolute',
            top: 'auto',
            right: theme.spacing(1),
            transition: theme.transitions.create(['width', 'opacity']),
            width: 0,
            height: '100%',
            bottom: 'auto',
            left: 0,
            borderRadius: 1,
        },
        '&:hover': {
            '&::before': {
                opacity: 0.25,
                height: '100%',
                width: 2,
            },
        },
        '&::active, &::focus': {
            '&::before': {
                opacity: 0.7,
                height: '100%',
                width: 2,
            },
        },
        '&.Mui-active': {
            fontWeight: 700,
            '&::before': {
                opacity: 0.7,
                height: '100%',
                width: 2,
            },
        },
    },
}); };
/**
 * @public
 */
var NavButton = forwardRef(function (_a, ref) {
    var classes = _a.classes, className = _a.className, active = _a.active, TouchRippleProps = _a.TouchRippleProps, variant = _a.variant, size = _a.size, _b = _a.disableRipple, disableRipple = _b === void 0 ? true : _b, _c = _a.disableTouchRipple, disableTouchRipple = _c === void 0 ? true : _c, restProps = __rest(_a, ["classes", "className", "active", "TouchRippleProps", "variant", "size", "disableRipple", "disableTouchRipple"]);
    var _d = classes || {
        touchRipple: null,
        topRow: null,
        sizeSmall: null,
        dense: null,
        vertical: null,
        active: null,
    }, touchRippleClassName = _d.touchRipple, topRow = _d.topRow, sizeSmall = _d.sizeSmall, dense = _d.dense, vertical = _d.vertical, activeClassName = _d.active, restClasses = __rest(_d, ["touchRipple", "topRow", "sizeSmall", "dense", "vertical", "active"]);
    var _e = TouchRippleProps || { className: null }, touchRipplePropsClassName = _e.className, restTouchRippleProps = __rest(_e, ["className"]);
    var ModifiedTouchRippleProps = __assign(__assign({}, restTouchRippleProps), { className: clsx(touchRippleClassName, touchRipplePropsClassName) });
    return (React.createElement(MuiButtonBase, __assign({}, restProps, { className: clsx(variant === 'topRow' && topRow, size === 'small' && sizeSmall, variant === 'dense' && dense, variant === 'vertical' && vertical, active && activeClassName, active && 'Mui-active', variant === 'topRow' && 'NavButton-topRow', size === 'small' && 'NavButton-sizeSmall', className), disableRipple: disableRipple, disableTouchRipple: disableTouchRipple, classes: restClasses, TouchRippleProps: ModifiedTouchRippleProps, ref: ref })));
});
export default withStyles(styles, { name: 'BwNavButton' })(NavButton);
/** @private @internal for docs only! */
export var DocsNavButton = function (props) { return (React.createElement(NavButton, __assign({}, props))); };
//# sourceMappingURL=NavButton.js.map